import { render, staticRenderFns } from "./T1PotwierdzenieContent.vue?vue&type=template&id=683bdb13&scoped=true&"
import script from "./T1PotwierdzenieContent.vue?vue&type=script&lang=js&"
export * from "./T1PotwierdzenieContent.vue?vue&type=script&lang=js&"
import style0 from "./T1PotwierdzenieContent.vue?vue&type=style&index=0&id=683bdb13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683bdb13",
  null
  
)

export default component.exports